/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { WidgetDateRangeCustom } from './WidgetDateRangeCustom';
import {
    instanceOfWidgetDateRangeCustom,
    WidgetDateRangeCustomFromJSON,
    WidgetDateRangeCustomFromJSONTyped,
    WidgetDateRangeCustomToJSON,
} from './WidgetDateRangeCustom';
import type { WidgetDateRangePreset } from './WidgetDateRangePreset';
import {
    instanceOfWidgetDateRangePreset,
    WidgetDateRangePresetFromJSON,
    WidgetDateRangePresetFromJSONTyped,
    WidgetDateRangePresetToJSON,
} from './WidgetDateRangePreset';

/**
 * @type SecurityWidgetQueryRequestDateRange
 * 
 * @export
 */
export type SecurityWidgetQueryRequestDateRange = WidgetDateRangeCustom | WidgetDateRangePreset;

export function SecurityWidgetQueryRequestDateRangeFromJSON(json: any): SecurityWidgetQueryRequestDateRange {
    return SecurityWidgetQueryRequestDateRangeFromJSONTyped(json, false);
}

export function SecurityWidgetQueryRequestDateRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityWidgetQueryRequestDateRange {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfWidgetDateRangeCustom(json)) {
        return WidgetDateRangeCustomFromJSONTyped(json, true);
    }
    if (instanceOfWidgetDateRangePreset(json)) {
        return WidgetDateRangePresetFromJSONTyped(json, true);
    }

    return {} as any;
}

export function SecurityWidgetQueryRequestDateRangeToJSON(json: any): any {
    return SecurityWidgetQueryRequestDateRangeToJSONTyped(json, false);
}

export function SecurityWidgetQueryRequestDateRangeToJSONTyped(value?: SecurityWidgetQueryRequestDateRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfWidgetDateRangeCustom(value)) {
        return WidgetDateRangeCustomToJSON(value as WidgetDateRangeCustom);
    }
    if (instanceOfWidgetDateRangePreset(value)) {
        return WidgetDateRangePresetToJSON(value as WidgetDateRangePreset);
    }

    return {};
}

